import supabase from 'lib/supabase-browser'
import { fetchSubmissions } from './db'
import { Podcast } from 'lib/types/generated-types'

export async function fetchPodcast(id: string): Promise<Podcast> {
  const { data: podcast, error } = await supabase
    .from('podcasts')
    .select('*')
    .eq('id', Number(id))
    .single()

  if (error) {
    console.error('Error fetching podcast:', id, error.message)
    throw new Error(error.message)
  }

  return podcast!
}

export async function fetchPodcasts(): Promise<Podcast[]> {
  const res = await fetchSubmissions({ page: 1, perPage: 5, projectId: 1 })

  const { data: podcasts, error } = await supabase
    .from('podcasts')
    .select('*')
    .in(
      'id',
      res.submissions
        .map((submission) => submission.podcast_id)
        .filter(Boolean) as number[]
    )

  if (error) {
    console.error('Error fetching podcasts:', error.message)
    throw new Error(error.message)
  }

  return podcasts!
}

export async function upsertPodcast(podcast: Partial<Podcast>): Promise<any> {
  const { data, error } = await supabase
    .from('podcasts')
    .upsert([{ ...podcast, owner: podcast.owner || '' }], { onConflict: 'id' })
    .select()

  if (error) {
    console.error('Error adding podcast:', error.message)
    throw new Error(error.message)
  }

  const dbPodcast = data![0]
  return dbPodcast
}
